import mmlogo from '../../assets/img/mmlogo.svg'

function Logo () {
    return(
        <div className="pl-6 pr-2 py-3 bg-red-c2">
            <img src={mmlogo} alt="Logo da MM" className="h-8 object-contain max-w-full"/>
        </div>
    )
}

export default Logo